<template>
    <div class="home" :class="$vuetify.breakpoint.smAndDown ? 'mt-6' : ''">
        <v-flex>
            <v-row class="ma-3 px-3 pt-3 pb-0" align="center" justify="center">
                <v-col class="mx-auto mt-5" cols="12" xs="6" lg="12">
                    <v-card
                        :color="colorPainel"
                        shaped
                        outlined
                        block
                        elevation="1"
                        max-width="calc(100%)"
                    >
                        <v-row class="d-flex align-center" no-gutters>
                            <v-col
                                class="d-flex align-center"
                                cols="auto"
                                style="flex: 1 1 auto; min-width: 0;"
                            >
                                <v-card-title
                                    v-bind:style="{
                                        color: dashboardColorFontTitle
                                    }"
                                    class="title font-weight-normal ml-5 mb-0"
                                    style="padding-right: 24px;"
                                >
                                    <v-icon class="mr-3" color="white">
                                        mdi-dots-grid
                                    </v-icon>
                                    <div
                                        :class="
                                            $vuetify.breakpoint.smAndDown
                                                ? 'text-subtitle-1 font-weight-bold ml-4'
                                                : ''
                                        "
                                    >
                                        Olá {{ computedGetUserName }}
                                    </div>
                                </v-card-title>
                            </v-col>
                            <v-col
                                cols="auto"
                                :class="{
                                    'd-flex align-center justify-end': !isMobile,
                                    'd-flex align-center justify-center': isMobile
                                }"
                                :style="{
                                    'min-width': isMobile ? '100%' : '220px',
                                    'max-width': isMobile ? '100%' : '250px',
                                    'margin-top': '15px',
                                    'margin-right': isMobile ? '0' : '24px'
                                }"
                            >
                                <v-select
                                    v-model="periodoSelecionado"
                                    :items="periodoOptions"
                                    label="Período"
                                    outlined
                                    dense
                                    :disabled="isMobile"
                                    @change="onPeriodoChange"
                                    color="white"
                                    background-color="white"
                                    label-color="white"
                                    class="white--text periodo-select"
                                    :style="{
                                        'min-width': isMobile ? '80%' : '180px',
                                        'max-width': isMobile ? '80%' : 'none'
                                    }"
                                    hide-details
                                ></v-select>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>

            <v-row :class="rowMarginClass" class="mt-0 mb-2">
                <v-col cols="12">
                    <v-card>
                        <v-card-title class="pb-2">
                            <v-icon left>mdi-filter</v-icon>
                            Filtros
                        </v-card-title>
                        <v-card-text class="pt-0">
                            <v-row align="center">
                                <v-col
                                    cols="12"
                                    sm="6"
                                    md="4"
                                    lg="4"
                                    class="d-flex flex-row align-center"
                                >
                                    <v-autocomplete
                                        :loading="loadingCedentesSacadores"
                                        outlined
                                        dense
                                        class="flex-grow-1"
                                        label="Nome do Cedente"
                                        hint="Selecione um cedente para filtrar os dados"
                                        placeholder="Ex.: João Silva"
                                        clearable
                                        v-model="filtros.nm_cedente"
                                        :items="cedentesSacadores"
                                        item-text="nm_cedente_favorecido"
                                        item-value="nm_cedente_favorecido"
                                        no-data-text="Nenhum cedente encontrado"
                                        @input="onCedenteChange"
                                        hide-details="auto"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="6"
                                    md="4"
                                    lg="4"
                                    class="d-flex flex-row align-center"
                                >
                                    <v-autocomplete
                                        :loading="loadingCedentesSacadores"
                                        outlined
                                        dense
                                        class="flex-grow-1"
                                        label="Nome do Sacador"
                                        hint="Selecione um sacador para filtrar os dados"
                                        placeholder="Ex.: Maria Santos"
                                        clearable
                                        v-model="filtros.nm_sacador"
                                        :items="sacadoresFiltrados"
                                        item-text="nm_sacador"
                                        item-value="nm_sacador"
                                        no-data-text="Nenhum sacador encontrado"
                                        @input="onSacadorChange"
                                        hide-details="auto"
                                    ></v-autocomplete>
                                </v-col>
                                <!-- <v-col
                                    cols="12"
                                    sm="6"
                                    md="4"
                                    lg="4"
                                    class="d-flex flex-row align-center"
                                >
                                    <v-text-field
                                        outlined
                                        dense
                                        class="flex-grow-1"
                                        label="CNPJ do Sacador"
                                        hint="CNPJ será preenchido automaticamente ao selecionar cedente/sacador"
                                        placeholder="Ex.: 12.345.678/0001-90"
                                        clearable
                                        v-model="filtros.cnpj_sacador"
                                        v-mask="'XX.XXX.XXX/XXXX-##'"
                                        readonly
                                        hide-details="auto"
                                    ></v-text-field>
                                </v-col> -->
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <!-- <v-row :class="rowMarginClass" class="mt-3 justify-center">
                <v-col
                    cols="12"
                    sm="4"
                    md="3"
                    lg="2"
                    class="d-flex justify-center"
                >
                    <v-select
                        v-model="periodoSelecionado"
                        :items="periodoOptions"
                        label="Período"
                        outlined
                        dense
                        :disabled="isMobile"
                        @change="onPeriodoChange"
                    ></v-select>
                </v-col>
            </v-row> -->

            <v-row :class="rowMarginClass" class="mt-0 mb-4">
                <v-col cols="12" xs="12" lg="6" class="mt-6 pt-0 px-4 pb-4">
                    <v-card style="height: 100%;">
                        <v-sheet
                            class="v-sheet--offset mx-auto"
                            :color="colorPainel"
                            elevation="1"
                            width="calc(100% - 32px)"
                        >
                            <v-card-title
                                class="white--text title font-weight-bold"
                            >
                                Upload de Títulos Efetivados no Sistema
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            small
                                            color="white"
                                            v-bind="attrs"
                                            v-on="on"
                                            class="my-auto ml-1"
                                        >
                                            help
                                        </v-icon>
                                    </template>
                                    <span>
                                        <div
                                            class="font-weight-regular white--text caption"
                                        >
                                            Dados pertencentes a somatória de
                                            todos os títulos com upload
                                            efetivado no sistema dentro dos
                                            últimos
                                            {{
                                                periodoOptions.find(
                                                    opt =>
                                                        opt.value ===
                                                        periodoSelecionado
                                                )?.text || ''
                                            }}
                                            <b
                                                >(títulos irregulares não
                                                inclusos)</b
                                            >
                                        </div>
                                    </span>
                                </v-tooltip>
                            </v-card-title>
                        </v-sheet>
                        <v-row>
                            <v-col cols="12">
                                <Loading
                                    :active="carregandoTotalUploads"
                                    :is-full-page="false"
                                />
                                <div class="ma-3 ">
                                    <div v-if="!hasChartData(dataTotalUpload)">
                                        <v-alert
                                            type="info"
                                            dense
                                            text
                                            :class="
                                                isPartner
                                                    ? 'bvs-white-label'
                                                    : ''
                                            "
                                        >
                                            Nenhum dado disponível para o
                                            período selecionado.
                                        </v-alert>
                                    </div>
                                    <chartTotalUploads
                                        v-else
                                        class="mt-5"
                                        :height="300"
                                        :chart-data="dataTotalUpload"
                                        style="background-color: white;"
                                    >
                                    </chartTotalUploads>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
                <v-col cols="12" xs="12" lg="6" class="mt-6 pt-0 px-4 pb-4">
                    <v-card style="height: 100%;">
                        <v-sheet
                            class="v-sheet--offset mx-auto"
                            :color="colorPainel"
                            elevation="1"
                            width="calc(100% - 32px)"
                        >
                            <v-card-title
                                class="white--text title font-weight-bold"
                            >
                                Desistências, Cancelamentos, Anuências e Pagos
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            small
                                            color="white"
                                            v-bind="attrs"
                                            v-on="on"
                                            class="my-auto ml-1"
                                        >
                                            help
                                        </v-icon>
                                    </template>
                                    <span>
                                        <div
                                            class="font-weight-regular white--text caption"
                                        >
                                            Dados dos últimos
                                            {{
                                                periodoOptions.find(
                                                    opt =>
                                                        opt.value ===
                                                        periodoSelecionado
                                                )?.text || ''
                                            }}
                                            de títulos com os seguintes
                                            comandos: 231 (Enviado à
                                            desistência), 241 (Enviado à
                                            Cancelamento), 251 (Enviado à
                                            Anuência), 101 (Pagos) e 107
                                            (Liquidação em condicional)
                                        </div>
                                    </span>
                                </v-tooltip>
                            </v-card-title>
                        </v-sheet>
                        <v-row>
                            <v-col cols="12">
                                <Loading
                                    :active="carregandoChartRecuperados"
                                    :is-full-page="false"
                                />
                                <div class="ma-3 ">
                                    <div v-if="!hasChartData(dataRecuperados)">
                                        <v-alert
                                            type="info"
                                            dense
                                            text
                                            :class="
                                                isPartner
                                                    ? 'bvs-white-label'
                                                    : ''
                                            "
                                        >
                                            Nenhum dado disponível para o
                                            período selecionado.
                                        </v-alert>
                                    </div>
                                    <chartRecuperados
                                        v-else
                                        class="mt-5"
                                        :height="300"
                                        :chart-data="dataRecuperados"
                                        style="background-color: white;"
                                    >
                                    </chartRecuperados>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
            <v-row :class="rowMarginClass" class="mt-0 mb-4">
                <v-col cols="12" xs="12" lg="6" class="mt-6 pt-0 px-4 pb-4">
                    <v-card style="height: 100%;">
                        <v-sheet
                            class="v-sheet--offset mx-auto"
                            :color="colorPainel"
                            elevation="1"
                            width="calc(100% - 32px)"
                        >
                            <v-card-title
                                class="white--text title font-weight-bold"
                            >
                                Valores Enviados para Protesto
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            small
                                            color="white"
                                            v-bind="attrs"
                                            v-on="on"
                                            class="my-auto ml-1"
                                        >
                                            help
                                        </v-icon>
                                    </template>
                                    <span>
                                        <div
                                            class="font-weight-regular white--text caption"
                                        >
                                            Valores totais enviados para
                                            protesto nos últimos
                                            {{
                                                periodoOptions.find(
                                                    opt =>
                                                        opt.value ===
                                                        periodoSelecionado
                                                )?.text || ''
                                            }}.
                                        </div>
                                    </span>
                                </v-tooltip>
                            </v-card-title>
                        </v-sheet>
                        <v-row>
                            <v-col cols="12">
                                <Loading
                                    :active="carregandoValoresEnviados"
                                    :is-full-page="false"
                                />
                                <div class="ma-3 ">
                                    <div
                                        v-if="
                                            !hasChartData(dataValoresEnviados)
                                        "
                                    >
                                        <v-alert
                                            type="info"
                                            dense
                                            text
                                            :class="
                                                isPartner
                                                    ? 'bvs-white-label'
                                                    : ''
                                            "
                                        >
                                            Nenhum dado disponível para o
                                            período selecionado.
                                        </v-alert>
                                    </div>
                                    <chartTotalUploads
                                        v-else
                                        class="mt-5"
                                        :height="300"
                                        color="red"
                                        :chart-data="dataValoresEnviados"
                                        style="background-color: white;"
                                    >
                                    </chartTotalUploads>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
                <v-col cols="12" xs="12" lg="6" class="mt-6 pt-0 px-4 pb-4">
                    <v-card style="height: 100%;">
                        <v-sheet
                            class="v-sheet--offset mx-auto"
                            :color="colorPainel"
                            elevation="1"
                            width="calc(100% - 32px)"
                        >
                            <v-card-title
                                class="white--text title font-weight-bold"
                            >
                                Valores Recuperados
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            small
                                            color="white"
                                            v-bind="attrs"
                                            v-on="on"
                                            class="my-auto ml-1"
                                        >
                                            help
                                        </v-icon>
                                    </template>
                                    <span>
                                        <div
                                            class="font-weight-regular white--text caption"
                                        >
                                            Valores totais recuperados por
                                            status nos últimos
                                            {{
                                                periodoOptions.find(
                                                    opt =>
                                                        opt.value ===
                                                        periodoSelecionado
                                                )?.text || ''
                                            }}.
                                        </div>
                                    </span>
                                </v-tooltip>
                            </v-card-title>
                        </v-sheet>
                        <v-row>
                            <v-col cols="12">
                                <Loading
                                    :active="carregandoValoresRecuperados"
                                    :is-full-page="false"
                                />
                                <div class="ma-3 ">
                                    <div
                                        v-if="
                                            !hasChartData(
                                                dataValoresRecuperados
                                            )
                                        "
                                    >
                                        <v-alert
                                            type="info"
                                            dense
                                            text
                                            :class="
                                                isPartner
                                                    ? 'bvs-white-label'
                                                    : ''
                                            "
                                        >
                                            Nenhum dado disponível para o
                                            período selecionado.
                                        </v-alert>
                                    </div>
                                    <chartTotalUploads
                                        v-else
                                        class="mt-5"
                                        :height="300"
                                        color="red"
                                        :chart-data="dataValoresRecuperados"
                                        style="background-color: white;"
                                    >
                                    </chartTotalUploads>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
            <v-row :class="rowMarginClass" class="mt-0 mb-4">
                <v-col cols="12" xs="12" lg="12" class="mt-6 pt-0 px-4 pb-4">
                    <v-card class="mt-2 mx-auto">
                        <v-sheet
                            class="v-sheet--offset mx-auto"
                            :color="colorPainel"
                            elevation="1"
                            width="calc(100% - 32px)"
                        >
                            <v-card-title
                                class="white--text title font-weight-bold"
                            >
                                Resumo de Títulos Existentes
                            </v-card-title>
                        </v-sheet>
                        <v-data-table
                            v-intersect="onIntersect"
                            :headers="headers"
                            :items="titulosExistentes"
                            :header-props="headerProps"
                            :loading="carregandoDataTable"
                            hide-default-footer
                            disable-pagination
                            dense
                            fixed-header
                            class="elevation-1"
                        >
                            <template v-slot:[`item.ds_status`]="{ item }">
                                <span
                                    :style="{
                                        fontWeight:
                                            item.ds_status ===
                                            'Irregulares Não Reapresentados'
                                                ? 'bold'
                                                : 'normal'
                                    }"
                                >
                                    {{ item.ds_status }}
                                    <template
                                        v-if="
                                            item.ds_status ===
                                                'Irregulares Não Reapresentados'
                                        "
                                    >
                                        <a
                                            :href="
                                                '/consulta-titulos?irregularesNaoReapresentados=1'
                                            "
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            class="ml-2"
                                        >
                                            <v-icon small
                                                >mdi-open-in-new</v-icon
                                            >
                                        </a>
                                    </template>
                                </span>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            small
                                            color="grey"
                                            v-bind="attrs"
                                            v-on="on"
                                            class="my-auto ml-1"
                                        >
                                            help
                                        </v-icon>
                                    </template>
                                    <span>{{
                                        getTooltipByStatus(item.ds_status)
                                    }}</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
                <!-- <v-col cols="12" xs="12" lg="6" class="mt-6 pt-0 px-4 pb-4"> -->
                <!-- <v-card class="mt-2 mx-auto">
                        <v-sheet
                            class="v-sheet--offset mx-auto"
                            :color="colorPainel"
                            elevation="1"
                            width="calc(100% - 32px)"
                        >
                            <v-card-title
                                class="white--text title font-weight-bold"
                            >
                                Quadro de Informações
                            </v-card-title>
                        </v-sheet>
                        <v-data-table
                            :headers="quadroHeaders"
                            :items="
                                carregandoQuadroInformacoes ? [] : quadroItems
                            "
                            :loading="carregandoQuadroInformacoes"
                            hide-default-footer
                            disable-pagination
                            dense
                            class="remove-border-table"
                        >
                            <template v-slot:loading>
                                <v-skeleton-loader
                                    v-for="n in 5"
                                    :key="n"
                                    type="list-item"
                                ></v-skeleton-loader>
                            </template>
                        </v-data-table>

                        <v-card class="mt-2 mx-auto">
                            <v-expansion-panels @change="onPanelChange">
                                <v-expansion-panel>
                                    <v-expansion-panel-header hide-actions>
                                        <div
                                            class="d-flex align-center justify-center"
                                            style="width: 100%"
                                        >
                                            <div class="d-flex align-center">
                                                <v-sheet
                                                    class="v-sheet--offset mr-4"
                                                    :color="colorPainel"
                                                    elevation="12"
                                                    max-width="fit-content"
                                                >
                                                </v-sheet>
                                                <div
                                                    :style="{
                                                        color: titleColorFont
                                                    }"
                                                    style="font-size: 1.25rem"
                                                    class="font-weight-bold d-flex align-center"
                                                >
                                                    Relatório de E-mails dos
                                                    últimos 90 dias
                                                    <v-icon class="ml-2">{{
                                                        showIcon
                                                    }}</v-icon>
                                                </div>
                                            </div>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-col
                                            style="padding-bottom: 0px;padding-top: 0px;"
                                        >
                                            <v-row
                                                style="padding-bottom: 0px;padding-top: 0px;"
                                            >
                                                <v-col
                                                    sm="6"
                                                    lg="3"
                                                    style="display: grid"
                                                >
                                                    <div class="grey--text">
                                                        E-mails Enviados
                                                    </div>
                                                    <div
                                                        :style="{
                                                            color: titleColorFont
                                                        }"
                                                        class="font-weight-bold display-1 d-flex justify-center align-end"
                                                    >
                                                        <v-progress-circular
                                                            v-if="
                                                                carregandoRelatorioEmails
                                                            "
                                                            color="primary"
                                                            small
                                                            indeterminate
                                                        />
                                                        <div v-else>
                                                            {{
                                                                relatorioEmails.emails_enviados
                                                            }}
                                                        </div>
                                                    </div>
                                                </v-col>
                                                <v-col
                                                    sm="6"
                                                    lg="3"
                                                    style="display: grid"
                                                >
                                                    <div class="grey--text">
                                                        E-mails Recebidos
                                                    </div>
                                                    <div
                                                        :style="{
                                                            color: titleColorFont
                                                        }"
                                                        class="font-weight-bold display-1 d-flex justify-center align-end"
                                                    >
                                                        <v-progress-circular
                                                            v-if="
                                                                carregandoRelatorioEmails
                                                            "
                                                            color="primary"
                                                            small
                                                            indeterminate
                                                        />
                                                        <div v-else>
                                                            {{
                                                                relatorioEmails.emails_recebidos
                                                            }}
                                                        </div>
                                                    </div>
                                                </v-col>
                                                <v-col
                                                    sm="6"
                                                    lg="3"
                                                    style="display: grid"
                                                >
                                                    <div class="grey--text">
                                                        E-mails Abertos
                                                    </div>
                                                    <div
                                                        :style="{
                                                            color: titleColorFont
                                                        }"
                                                        class="font-weight-bold display-1 d-flex justify-center align-end"
                                                    >
                                                        <v-progress-circular
                                                            v-if="
                                                                carregandoRelatorioEmails
                                                            "
                                                            color="primary"
                                                            small
                                                            indeterminate
                                                        />
                                                        <div v-else>
                                                            {{
                                                                relatorioEmails.emails_abertos
                                                            }}
                                                        </div>
                                                    </div>
                                                </v-col>
                                                <v-col
                                                    sm="6"
                                                    lg="3"
                                                    style="display: grid"
                                                >
                                                    <div class="grey--text">
                                                        E-mails com link
                                                        acessado
                                                    </div>
                                                    <div
                                                        :style="{
                                                            color: titleColorFont
                                                        }"
                                                        class="font-weight-bold display-1 d-flex justify-center align-end"
                                                    >
                                                        <v-progress-circular
                                                            v-if="
                                                                carregandoRelatorioEmails
                                                            "
                                                            color="primary"
                                                            small
                                                            indeterminate
                                                        />
                                                        <div v-else>
                                                            {{
                                                                relatorioEmails.emails_com_link_de_contato_acessado
                                                            }}
                                                        </div>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                            <v-divider class="my-1"></v-divider>
                                            <v-icon class="mr-2" small>
                                                mdi-clock
                                            </v-icon>
                                            <span
                                                class="caption grey--text font-weight-light"
                                                >Atualizado desde o último
                                                acesso</span
                                            >
                                        </v-col>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-card>
                    </v-card> -->
                <!-- </v-col> -->
            </v-row>
            <v-row>
                <v-card class="mt-2 mb-8 mx-auto">
                    <v-expansion-panels @change="onPanelChange">
                        <v-expansion-panel>
                            <v-expansion-panel-header hide-actions>
                                <div
                                    class="d-flex align-center justify-center"
                                    style="width: 100%"
                                >
                                    <div class="d-flex align-center">
                                        <v-sheet
                                            class="v-sheet--offset mr-4"
                                            :color="colorPainel"
                                            elevation="12"
                                            max-width="fit-content"
                                        >
                                        </v-sheet>
                                        <div
                                            :style="{
                                                color: titleColorFont
                                            }"
                                            style="font-size: 1.25rem"
                                            class="font-weight-bold d-flex align-center"
                                        >
                                            Relatório de E-mails dos últimos 90
                                            dias
                                            <v-icon class="ml-2">{{
                                                showIcon
                                            }}</v-icon>
                                        </div>
                                    </div>
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-col
                                    style="padding-bottom: 0px;padding-top: 0px;"
                                >
                                    <v-row
                                        style="padding-bottom: 0px;padding-top: 0px;"
                                    >
                                        <v-col
                                            sm="6"
                                            lg="3"
                                            style="display: grid"
                                        >
                                            <div class="grey--text">
                                                E-mails Enviados
                                            </div>
                                            <div
                                                :style="{
                                                    color: titleColorFont
                                                }"
                                                class="font-weight-bold display-1 d-flex justify-center align-end"
                                            >
                                                <v-progress-circular
                                                    v-if="
                                                        carregandoRelatorioEmails
                                                    "
                                                    color="primary"
                                                    small
                                                    indeterminate
                                                />
                                                <div v-else>
                                                    {{
                                                        relatorioEmails.emails_enviados
                                                    }}
                                                </div>
                                            </div>
                                        </v-col>
                                        <v-col
                                            sm="6"
                                            lg="3"
                                            style="display: grid"
                                        >
                                            <div class="grey--text">
                                                E-mails Recebidos
                                            </div>
                                            <div
                                                :style="{
                                                    color: titleColorFont
                                                }"
                                                class="font-weight-bold display-1 d-flex justify-center align-end"
                                            >
                                                <v-progress-circular
                                                    v-if="
                                                        carregandoRelatorioEmails
                                                    "
                                                    color="primary"
                                                    small
                                                    indeterminate
                                                />
                                                <div v-else>
                                                    {{
                                                        relatorioEmails.emails_recebidos
                                                    }}
                                                </div>
                                            </div>
                                        </v-col>
                                        <v-col
                                            sm="6"
                                            lg="3"
                                            style="display: grid"
                                        >
                                            <div class="grey--text">
                                                E-mails Abertos
                                            </div>
                                            <div
                                                :style="{
                                                    color: titleColorFont
                                                }"
                                                class="font-weight-bold display-1 d-flex justify-center align-end"
                                            >
                                                <v-progress-circular
                                                    v-if="
                                                        carregandoRelatorioEmails
                                                    "
                                                    color="primary"
                                                    small
                                                    indeterminate
                                                />
                                                <div v-else>
                                                    {{
                                                        relatorioEmails.emails_abertos
                                                    }}
                                                </div>
                                            </div>
                                        </v-col>
                                        <v-col
                                            sm="6"
                                            lg="3"
                                            style="display: grid"
                                        >
                                            <div class="grey--text">
                                                E-mails com link acessado
                                            </div>
                                            <div
                                                :style="{
                                                    color: titleColorFont
                                                }"
                                                class="font-weight-bold display-1 d-flex justify-center align-end"
                                            >
                                                <v-progress-circular
                                                    v-if="
                                                        carregandoRelatorioEmails
                                                    "
                                                    color="primary"
                                                    small
                                                    indeterminate
                                                />
                                                <div v-else>
                                                    {{
                                                        relatorioEmails.emails_com_link_de_contato_acessado
                                                    }}
                                                </div>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-divider class="my-1"></v-divider>
                                    <v-icon class="mr-2" small>
                                        mdi-clock
                                    </v-icon>
                                    <span
                                        class="caption grey--text font-weight-light"
                                        >Atualizado desde o último acesso</span
                                    >
                                </v-col>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-card>
            </v-row>
        </v-flex>
        <ConfirmacaoModal
            v-if="mostrarModalConfirmacao"
            :showDialog="mostrarModalConfirmacao"
            :tituloModal="tituloModalConfirmacao"
            :textoModal="textoModalConfirmacao"
            :btnConfirmarEmit="btnConfirmarModalConfirmacao"
            :btnConfirmar="'Ok'"
            :esconderCancelar="esconderCancelar"
            @confirmarAviso="aceitarModalAviso"
            @fecharModal="aceitarModalAviso"
        />

        <v-dialog
            v-model="dialogImagemExpandida"
            :max-width="isFullscreen ? '100vw' : '600px'"
            :max-height="isFullscreen ? '100vh' : '80vh'"
            overlay-opacity="0.9"
            :persistent="loadingImagem"
            @click:outside="loadingImagem ? null : fecharImagemExpandida"
        >
            <v-card v-if="imagemSelecionada" class="pa-0">
                <v-toolbar color="primary" dark>
                    <v-toolbar-title>{{
                        imagemSelecionada.assunto
                    }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="fecharImagemExpandida"
                        :disabled="loadingImagem"
                    >
                        <v-progress-circular
                            v-if="loadingImagem"
                            indeterminate
                            size="20"
                        ></v-progress-circular>
                        <v-icon v-else>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pa-4">
                    <v-img
                        :src="imagemSelecionada.imagem_url"
                        :alt="imagemSelecionada.assunto"
                        contain
                        :class="loadingImagem ? '' : 'cursor-pointer'"
                        style="width: 100%; height: 100%; object-fit: cover;"
                        :style="
                            isFullscreen
                                ? {
                                      position: 'fixed',
                                      top: '0',
                                      left: '0',
                                      width: '100vw',
                                      height: '100vh',
                                      zIndex: 9999,
                                      backgroundColor: 'black'
                                  }
                                : {}
                        "
                        @click="
                            loadingImagem
                                ? null
                                : (isFullscreen = !isFullscreen)
                        "
                    />
                    <div class="mt-4">
                        <p>
                            <strong>Assunto:</strong>
                            {{ imagemSelecionada.assunto }}
                        </p>
                        <p>
                            <strong>Data de Envio:</strong>
                            {{ formatarData(imagemSelecionada.data_envio) }}
                        </p>
                        <p>
                            <strong>Enviada por:</strong>
                            {{ imagemSelecionada.user.nm_user }} ({{
                                imagemSelecionada.user.ds_email
                            }})
                        </p>
                        <p class="text-center grey--text">
                            Clique na imagem para abrir em tela cheia
                        </p>
                    </div>
                </v-card-text>
                <v-card-actions class="justify-center pa-2">
                    <v-btn
                        @click="baixarImagem(imagemSelecionada)"
                        color="primary"
                        :disabled="loadingImagem"
                    >
                        <v-icon left>mdi-download</v-icon>
                        Baixar Imagem
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {
    default as chartRecuperados,
    default as chartTotalUploads
} from '@/helpers/homeChart1.js';
import ConfirmacaoModal from '@/modals/ConfirmacaoModal';
import ApresentanteService from '@/services/apresentanteService';
import ChartsService from '@/services/chartsService';
import DivulgacaoService from '@/services/DivulgacaoService';
import MensageriaService from '@/services/MensageriaService';
import TitulosHistoricoDataTableService from '@/services/titulosHistoricoDataTableService';
import Vue from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import DashboardService from '../services/DashboardService';

export default {
    name: 'home',
    components: {
        chartTotalUploads,
        chartRecuperados,
        Loading,
        ConfirmacaoModal
    },
    data() {
        return {
            periodoSelecionado: 365, // Default 12 meses, will be set in mounted()
            periodoOptions: [
                { text: '3 meses', value: 90 },
                { text: '6 meses', value: 180 },
                { text: '12 meses', value: 365 }
            ],
            isPanelExpanded: false,
            headerProps: {
                sortByText: 'Ordenar por'
            },
            apresentanteService: new ApresentanteService(Vue.http, this.$store),
            loadingCedentesSacadores: false,
            cedentesSacadores: [],
            cnpjCedenteSelecionado: null,
            filtros: {
                nm_cedente: null,
                nm_sacador: null,
                cnpj_sacador: null
            },
            mostrarModalConfirmacao: false,
            tituloModalConfirmacao: 'Aviso ',
            textoModalConfirmacao:
                '<b>Prezado parceiro</b><br /><br /> Você está usando um ambiente de homologação ( testes ).<br><br>Procedendo você concorda e confirma em não utilizar dados reais.<br><br> Obrigado, Equipe Recuperi',
            btnConfirmarModalConfirmacao: 'confirmarAviso',
            esconderCancelar: true,
            loadingModal: false,
            dataIntersect: false,
            isIntersecting: false,
            scaleClass: false,
            relatorioEmails: {
                emails_abertos: 0,
                emails_com_link_de_contato_acessado: 0,
                emails_enviados: 0,
                emails_recebidos: 0
            },
            graficos: {
                dt_inicio: null,
                dt_fim: null
            },
            ultimos30Dias: null,
            headers: [
                {
                    text: 'Status',
                    value: 'ds_status'
                },
                { text: 'Titulos', value: 'vl_count' },
                { text: 'Valor Total R$', value: 'sum_vl_saldo_protesto' }
            ],
            titulosExistentes: [],
            titulosExistentensTooltip: {
                Apontados:
                    "Títulos em fase de intimação aguardando retorno. 225 ('Apontado').",
                'Cancelados Anuídos':
                    "Títulos 121 ('Cancelado') por meio de envio de anuência (custos devedor).",
                'Cancelados Diretos':
                    "Títulos 121 ('Cancelado') por meio de envio de cancelamento (custos apresentante).",
                'Em Processo de Anuência':
                    "Títulos com status 250 ('Solicitado Anuência'), 251 ('Enviado à Anuência'), 252 ('Anuência Programada') e 144 ('Anuência confirmada no Cartório').",
                'Em Processo de Cancelamento':
                    "Títulos com status 240 ('Solicitado Cancelamento') e 241 ('Enviado a Cancelamento').",
                'Em Processo de Desistência':
                    "Títulos com status 230 ('Solicitado Desistência') e 231 ('Enviado à Desistência').",
                'Pagos / Liquidação em Condicional':
                    "Títulos pagos em cartório (valores repassados ao apresentante) 101 ('Pago') e 107 ('Liquidação em condicional').",
                Protestados: "Títulos Protestados 102 ('Protestado').",
                'Protestos Desistidos Antes do Envio':
                    "Títulos que não foram processados e enviados a protesto 233 ('Solicitação de Protesto Desistida') e 261 ('Upload cancelado').",
                'Retirados / Desistidos':
                    "Títulos retirados e desistidos por meio da desistência (custos apresentante) 103 ('Retirado').",
                'Total Irregulares':
                    "Títulos que voltaram irregular 105 ('Irregular - sem custas') e 106 ('Irregular - com custas').",
                'Irregulares Não Reapresentados':
                    'Títulos Irregulares que não foram reapresentados, podem ser corrigidos e reenviados.'
            },
            quadroHeaders: [
                { text: 'Informação', value: 'info' },
                { text: 'Total', value: 'valor' }
            ],
            quadroItems: [
                {
                    info: 'Quantidade de Títulos Enviados para Protesto',
                    valor: 0,
                    key: 'quantidade_enviados_protesto'
                },
                {
                    info: 'Quantidade de Títulos em Revisão',
                    valor: 0,
                    key: 'quantidade_em_revisao'
                },
                {
                    info: 'Quantidade de Títulos Cancelados',
                    valor: 0,
                    key: 'quantidade_cancelados'
                },
                {
                    info: 'Quantidade de Solicitação de Desistência',
                    valor: 0,
                    key: 'quantidade_desistencia'
                },
                {
                    info: 'Quantidade de Títulos em Anuência',
                    valor: 0,
                    key: 'quantidade_anuencia'
                }
            ],
            colorPainel: null,
            dashboardColorFont: '#757575',
            dashboardColorFontTitle: 'white',
            titleColorFont: '#757575',
            dataTotalUpload: null,
            dataRecuperados: null,
            dataValoresEnviados: null,
            dataValoresRecuperados: null,
            carregandoRelatorioEmails: false,
            carregandoDataTable: false,
            carregandoTotalUploads: false,
            carregandoChartRecuperados: false,
            carregandoValoresEnviados: false,
            carregandoValoresRecuperados: false,
            carregandoQuadroInformacoes: false,
            dialogImagemExpandida: false,
            imagemSelecionada: null,
            isFullscreen: false,
            loadingImagem: false
        };
    },
    computed: {
        sacadoresFiltrados() {
            if (!this.cnpjCedenteSelecionado) {
                return this.cedentesSacadores;
            }
            return this.cedentesSacadores.filter(
                item => item.cnpj_sacador === this.cnpjCedenteSelecionado
            );
        },
        userProfile() {
            return this.$store.getters.user;
        },
        isPartner() {
            return this.$store.getters.isPartner == 1;
        },
        computedGetUserName() {
            return this.$store.getters.getUserName;
        },
        abortCtrl() {
            return this.$store.getters.getAbortCtrl;
        },
        aceitouModal() {
            return this.$store.getters.aceitouModal;
        },
        showIcon() {
            return this.isPanelExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down';
        },
        rowMarginClass() {
            return this.$vuetify &&
                this.$vuetify.breakpoint &&
                this.$vuetify.breakpoint.xsOnly
                ? ''
                : 'mx-6';
        },
        isMobile() {
            return (
                this.$vuetify &&
                this.$vuetify.breakpoint &&
                this.$vuetify.breakpoint.xsOnly
            );
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeRouteLeave(to, from, next) {
        if (this.abortCtrl) {
            this.abortCtrl.abort();
            this.$store.commit('setAbortCtrl', new AbortController());
        }
        next();
    },
    mounted() {
        if (this.$store.getters.isPartner == 1) {
            this.usuarioPartner = true;
            this.dashboardColorFont = '#757575';
            this.dashboardColorFontTitle = 'white';
            this.titleColorFont = '#959ea6';
            this.colorPainel = '#959ea6';
        } else {
            this.dashboardColorFontTitle = 'white';
            this.dashboardColorFont = 'white';
            this.titleColorFont = this.$vuetify.theme.themes.light.primary;
            this.colorPainel = 'primary';

            if (
                this.userProfile?.ds_identidade_visual?.panel_color &&
                this.userProfile?.ds_identidade_visual?.panel_color !== ''
            ) {
                this.titleColorFont = this.userProfile.ds_identidade_visual.panel_color;
                this.colorPainel = this.userProfile.ds_identidade_visual.panel_color;
            }
        }

        if (!this.aceitouModal) {
            this.mostrarModalConfirmacao =
                document.location.href.indexOf('painel-hom.recuperi') > -1;
        }

        const controller = new AbortController();
        this.$store.commit('setAbortCtrl', controller);

        if (this.isMobile) {
            this.periodoSelecionado = 90;
        }

        this.getDataMounted();
        this.iniciarLoadingsMounted();
        this.initializeQuadroItems();
        this.getValoresEnviadosChart(this.periodoSelecionado);
        this.getValoresRecuperadosChart(this.periodoSelecionado);
        this.buscarCedentesSacadores();
        this.buscarAtualizacoes();
    },
    methods: {
        async buscarCedentesSacadores() {
            try {
                this.loadingCedentesSacadores = true;
                const response = await this.apresentanteService.getCedentesSacadoresPorApresentante();
                this.cedentesSacadores = response || [];
            } catch (error) {
                console.error('Erro ao buscar cedentes e sacadores:', error);
            } finally {
                this.loadingCedentesSacadores = false;
            }
        },
        onSacadorChange(selectedSacador) {
            if (selectedSacador) {
                const sacador = this.cedentesSacadores.find(
                    item => item.nm_sacador === selectedSacador
                );

                if (sacador) {
                    this.filtros.nm_sacador = selectedSacador;
                    this.filtros.cnpj_sacador = sacador.cnpj_sacador;
                    this.atualizarDashboard();
                }
            } else {
                this.filtros.nm_sacador = null;
                this.filtros.cnpj_sacador = null;
                this.atualizarDashboard();
            }
        },
        onCedenteChange(selectedCedente) {
            if (selectedCedente) {
                const cedente = this.cedentesSacadores.find(
                    item => item.nm_cedente_favorecido === selectedCedente
                );

                if (cedente) {
                    this.cnpjCedenteSelecionado = cedente.cnpj_sacador;

                    this.filtros.nm_sacador = null;
                    this.filtros.cnpj_sacador = null;
                    this.atualizarDashboard();
                }
            } else {
                this.cnpjCedenteSelecionado = null;
                this.atualizarDashboard();
            }
        },
        atualizarDashboard() {
            let filterParam = {};

            if (
                this.filtros.nm_cedente &&
                this.filtros.nm_cedente.trim() !== ''
            ) {
                filterParam.nm_cedente_favorecido = this.filtros.nm_cedente;
            }

            if (
                this.filtros.cnpj_sacador &&
                this.filtros.cnpj_sacador.trim() !== ''
            ) {
                filterParam.cnpj_sacador = this.filtros.cnpj_sacador;
            }

            const finalFilter =
                Object.keys(filterParam).length > 0 ? filterParam : null;

            this.getDataMounted(this.periodoSelecionado, finalFilter);
            this.getValoresEnviadosChart(this.periodoSelecionado, finalFilter);
            this.getValoresRecuperadosChart(
                this.periodoSelecionado,
                finalFilter
            );
            this.getDataTable(finalFilter);
            this.relatorioTotal(finalFilter);
        },
        aceitarModalAviso() {
            this.mostrarModalConfirmacao = false;
            this.$store.commit('setAceitouModal', true);
        },
        onIntersect(entries) {
            if (this.isIntersecting === false) {
                this.isIntersecting = entries[0].isIntersecting;
            }
            if (this.isIntersecting === true && this.dataIntersect === false) {
                this.iniciarLoadings();
                this.relatorioTotal();
                this.getDataTable();
                this.dataIntersect = true;
            }
        },
        getTooltipByStatus(status) {
            return this.titulosExistentensTooltip[status];
        },
        iniciarLoadingsMounted() {
            this.carregandoTotalUploads = true;
            this.carregandoChartRecuperados = true;
        },
        iniciarLoadings() {
            this.carregandoRelatorioEmails = true;
            this.carregandoDataTable = true;
        },
        relatorioTotal(filterParam = null) {
            console.log('Buscando relatório total com filtro:', filterParam);
            const mensageriaService = new MensageriaService(
                Vue.http,
                this.$store
            );
            mensageriaService
                .searchCountEmails(90)
                .then(response => {
                    if (response.status === 200) {
                        const data = response.data;
                        this.relatorioEmails = {
                            emails_enviados: data.count || 0,
                            emails_recebidos: data.delivered || 0,
                            emails_abertos: data.read || 0,
                            emails_com_link_de_contato_acessado: data.click || 0
                        };
                    }
                })
                .catch(e => {
                    console.log(e);
                })
                .finally(() => {
                    this.carregandoRelatorioEmails = false;
                });
        },
        getDataTable(filterParam = null) {
            var today = new Date();
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = today.getFullYear() - 1;
            var yyyyate = today.getFullYear();
            let dt_de = yyyy + '-' + mm + '-' + dd;
            let dt_ate = yyyyate + '-' + mm + '-' + dd;
            let TitulosHistorico = new TitulosHistoricoDataTableService(
                Vue.http,
                this.$store
            );

            TitulosHistorico.dadosHistoricoTitulos(dt_de, dt_ate, filterParam)
                .then(response => {
                    response.data = response.data.map(item => {
                        if (item.ds_status === 'Não Reapresentados') {
                            return {
                                ...item,
                                ds_status: 'Irregulares Não Reapresentados'
                            };
                        }
                        return item;
                    });
                    response.data.sort((a, b) => {
                        //ordernar até ser o primeiro
                        const _a =
                            a.ds_status === 'Irregulares Não Reapresentados';
                        const _b =
                            b.ds_status === 'Irregulares Não Reapresentados';
                        return _b - _a;
                    });
                    this.titulosExistentes = response.data;
                    this.carregandoDataTable = false;
                })
                .catch(e => {
                    console.log(e);
                });
        },
        fillDataTotalUpload() {
            this.dataTotalUpload = {
                labels: this.dataTotalUpload.anomes,
                datasets: [
                    {
                        label: 'Total de Títulos',
                        backgroundColor: 'rgb(25 118 210)',
                        borderColor: 'rgb(25 118 210)',
                        borderWidth: 1,
                        type: 'bar',
                        data: this.dataTotalUpload.titulos
                    }
                ],
                options: {
                    plugins: {
                        datalabels: {
                            display: true,
                            anchor: 'end',
                            align: 'end',
                            offset: 6,
                            color: 'white',
                            font: { weight: 'bold' },
                            backgroundColor: 'rgba(0,0,0,0.5)',
                            borderRadius: 4,
                            padding: 2,
                            formatter: function(value) {
                                return value !== null &&
                                    value !== undefined &&
                                    value > 0
                                    ? value.toLocaleString()
                                    : '0';
                            }
                        }
                    }
                }
            };
        },
        fillDataRecuperados() {
            const labels = this.dataRecuperados.anomes;
            const datasets = [
                {
                    label: 'Anuências',
                    backgroundColor: '#1976D2', // azul
                    borderColor: 'rgba(255,255,255,0.5)',
                    borderWidth: 1,
                    type: 'bar',
                    stack: 'stack1',
                    data: this.dataRecuperados.anuencias
                },
                {
                    label: 'Cancelamentos',
                    backgroundColor: '#FFEB3B', // amarelo
                    borderColor: 'rgba(255,255,255,0.5)',
                    borderWidth: 1,
                    type: 'bar',
                    stack: 'stack1',
                    data: this.dataRecuperados.cancelamentos
                },
                {
                    label: 'Desistências',
                    backgroundColor: '#E91E63', // magenta/rosa
                    borderColor: 'rgba(255,255,255,0.5)',
                    borderWidth: 1,
                    type: 'bar',
                    stack: 'stack1',
                    data: this.dataRecuperados.desistencias
                },
                {
                    label: 'Pagos',
                    backgroundColor: '#4CAF50', // verde
                    borderColor: 'rgba(255,255,255,0.5)',
                    borderWidth: 1,
                    type: 'bar',
                    stack: 'stack1',
                    data: this.dataRecuperados.pagos
                }
            ];

            this.dataRecuperados = {
                labels,
                datasets,
                options: {
                    legend: {
                        display: true,
                        position: 'bottom',
                        labels: {
                            usePointStyle: true,
                            fontColor: 'rgb(25 118 210)',
                            padding: 15,
                            boxWidth: 10
                        }
                    },
                    plugins: {
                        datalabels: {
                            display: function(context) {
                                const chart = context.chart;
                                const dataIndex = context.dataIndex;
                                for (
                                    let i = chart.data.datasets.length - 1;
                                    i >= 0;
                                    i--
                                ) {
                                    const meta = chart.getDatasetMeta(i);
                                    if (!meta.hidden && meta.data[dataIndex]) {
                                        return context.datasetIndex === i;
                                    }
                                }
                                return false;
                            },
                            anchor: 'end',
                            align: 'end',
                            offset: 6,
                            color: 'white',
                            font: { weight: 'bold' },
                            backgroundColor: 'rgba(0,0,0,0.5)',
                            borderRadius: 4,
                            padding: 2,
                            formatter: function(value, context) {
                                const chart = context.chart;
                                const dataIndex = context.dataIndex;
                                let total = 0;
                                chart.data.datasets.forEach((ds, i) => {
                                    const meta = chart.getDatasetMeta(i);
                                    if (!meta.hidden) {
                                        total += ds.data[dataIndex] || 0;
                                    }
                                });
                                return total > 0 ? total.toLocaleString() : '0';
                            }
                        }
                    },
                    tooltips: {
                        mode: 'index',
                        intersect: false
                    },
                    scales: {
                        xAxes: [
                            {
                                stacked: true,
                                barPercentage: 0.6,
                                categoryPercentage: 0.8,
                                gridLines: {
                                    display: false,
                                    color: 'white',
                                    borderColor: 'white'
                                },
                                ticks: {
                                    fontColor: 'rgb(25 118 210)',
                                    borderColor: 'rgb(25 118 210)'
                                }
                            }
                        ],
                        yAxes: [
                            {
                                stacked: true,
                                gridLines: {
                                    display: false
                                },
                                ticks: {
                                    fontColor: 'rgb(25 118 210)'
                                }
                            }
                        ]
                    }
                }
            };
        },
        formatBRL(value) {
            if (!value && value !== 0) return '';
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        },
        async getValoresEnviadosChart(days, filterParam = null) {
            this.carregandoValoresEnviados = true;
            try {
                const dashboardService = new DashboardService(
                    Vue.http,
                    this.$store
                );

                const response = await dashboardService.getValoresEnviados(
                    days,
                    filterParam
                );
                if (response.status === 200 && Array.isArray(response.data)) {
                    const labels = response.data.map(item =>
                        this.changeLabels(item.mes_ano_envio)
                    );
                    const valores = response.data.map(
                        item => item.valor_total_protestado
                    );

                    const formatBRL = this.formatBRL.bind(this);

                    this.dataValoresEnviados = {
                        labels,
                        datasets: [
                            {
                                label: 'Valor Total Protestado',
                                backgroundColor: 'rgb(25 118 210)',
                                borderColor: 'rgb(25 118 210)',
                                borderWidth: 1,
                                type: 'bar',
                                data: valores
                            }
                        ],
                        options: {
                            layout: {
                                padding: {
                                    top: 100
                                }
                            },
                            tooltips: {
                                callbacks: {
                                    label: function(tooltipItem) {
                                        return formatBRL(tooltipItem.yLabel);
                                    }
                                }
                            },
                            plugins: {
                                datalabels: {
                                    display: true,
                                    anchor: 'end',
                                    align: 'top',
                                    offset: 15,
                                    color: 'white',
                                    font: { weight: 'bold', size: 11 },
                                    backgroundColor: 'rgba(0,0,0,0.7)',
                                    borderRadius: 4,
                                    padding: {
                                        top: 5,
                                        bottom: 5,
                                        left: 5,
                                        right: 5
                                    },
                                    rotation: 90,
                                    formatter: function(value) {
                                        return value !== null &&
                                            value !== undefined &&
                                            value > 0
                                            ? formatBRL(value)
                                            : '0';
                                    }
                                }
                            },
                            scales: {
                                yAxes: [
                                    {
                                        stacked: false,
                                        gridLines: {
                                            display: false
                                        },
                                        ticks: {
                                            fontColor: 'rgb(25 118 210)',
                                            callback: function(value) {
                                                return formatBRL(value);
                                            }
                                        }
                                    }
                                ]
                            }
                        }
                    };
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.carregandoValoresEnviados = false;
            }
        },

        async getValoresRecuperadosChart(days, filterParam = null) {
            this.carregandoValoresRecuperados = true;
            try {
                const dashboardService = new DashboardService(
                    Vue.http,
                    this.$store
                );

                const response = await dashboardService.getValoresRecuperados(
                    days,
                    filterParam
                );
                if (response.status === 200 && Array.isArray(response.data)) {
                    const raw = response.data;
                    const months = Array.from(
                        new Set(raw.map(item => item.mes_ano_recuperado))
                    ).sort();
                    const statusCodes = Array.from(
                        new Set(raw.map(item => item.cd_status))
                    );
                    const statusLabels = {
                        241: 'Enviado Cancelamento',
                        251: 'Enviado Anuencia',
                        231: 'Enviada Desistencia',
                        101: 'Pago',
                        107: 'Liquidação em condicional'
                    };
                    const statusColors = [
                        '#1976D2', // azul
                        '#FFEB3B', // amarelo
                        '#E91E63', // magenta/rosa
                        '#4CAF50', // verde
                        '#FF9800', // laranja
                        '#00BCD4', // ciano
                        '#9C27B0', // roxo
                        '#F44336', // vermelho
                        '#8BC34A', // verde claro
                        '#FFC107' // amarelo escuro
                    ];
                    const datasets = statusCodes.map((status, idx) => ({
                        label: statusLabels[status] || status,
                        backgroundColor:
                            statusColors[idx % statusColors.length],
                        borderColor: 'rgba(255,255,255,0.5)',
                        borderWidth: 1,
                        type: 'bar',
                        stack: 'stack1',
                        data: months.map(month => {
                            const found = raw.find(
                                item =>
                                    item.mes_ano_recuperado === month &&
                                    item.cd_status === status
                            );
                            return found ? found.valor_total_recuperado : 0;
                        })
                    }));
                    const labels = months.map(this.changeLabels);

                    const formatBRL = this.formatBRL.bind(this);

                    this.dataValoresRecuperados = {
                        labels,
                        datasets,
                        options: {
                            layout: {
                                padding: {
                                    top: 100
                                }
                            },
                            legend: {
                                display: true,
                                position: 'bottom',
                                labels: {
                                    usePointStyle: true,
                                    fontColor: 'rgb(25 118 210)',
                                    padding: 15,
                                    boxWidth: 10
                                },
                                onClick: function(e, legendItem) {
                                    const index = legendItem.datasetIndex;
                                    const chart = this.chart;
                                    const meta = chart.getDatasetMeta(index);

                                    meta.hidden =
                                        meta.hidden === null
                                            ? !chart.data.datasets[index].hidden
                                            : null;

                                    chart.update();
                                }
                            },
                            tooltips: {
                                callbacks: {
                                    label: function(tooltipItem, data) {
                                        const datasetLabel =
                                            data.datasets[
                                                tooltipItem.datasetIndex
                                            ].label || '';
                                        const value = tooltipItem.yLabel;
                                        return (
                                            datasetLabel +
                                            ': ' +
                                            formatBRL(value)
                                        );
                                    }
                                }
                            },
                            plugins: {
                                datalabels: {
                                    display: function(context) {
                                        const value =
                                            context.dataset.data[
                                                context.dataIndex
                                            ];
                                        if (!value || value <= 0) return false;

                                        const meta = context.chart.getDatasetMeta(
                                            context.datasetIndex
                                        );
                                        if (meta.hidden) return false;

                                        for (
                                            let i = context.datasetIndex + 1;
                                            i <
                                            context.chart.data.datasets.length;
                                            i++
                                        ) {
                                            const otherMeta = context.chart.getDatasetMeta(
                                                i
                                            );
                                            if (
                                                !otherMeta.hidden &&
                                                context.chart.data.datasets[i]
                                                    .data[context.dataIndex] > 0
                                            ) {
                                                return false;
                                            }
                                        }
                                        return true;
                                    },
                                    anchor: 'end',
                                    align: 'top', // Muda para top para evitar corte
                                    offset: 15, // Aumenta o espaço entre a barra e o rótulo
                                    color: 'white',
                                    font: { weight: 'bold', size: 11 }, // Reduz levemente o tamanho da fonte
                                    backgroundColor: 'rgba(0,0,0,0.7)',
                                    borderRadius: 4,
                                    padding: {
                                        top: 5,
                                        bottom: 5,
                                        left: 5,
                                        right: 5
                                    },
                                    rotation: 90,
                                    formatter: function(value, context) {
                                        const dataIndex = context.dataIndex;
                                        const chart = context.chart;
                                        let total = 0;

                                        chart.data.datasets.forEach(
                                            (dataset, i) => {
                                                const meta = chart.getDatasetMeta(
                                                    i
                                                );
                                                if (!meta.hidden) {
                                                    const val =
                                                        dataset.data[dataIndex];
                                                    if (val && !isNaN(val)) {
                                                        total += Number(val);
                                                    }
                                                }
                                            }
                                        );

                                        if (total <= 0) return '';
                                        return formatBRL(total);
                                    }
                                }
                            },
                            scales: {
                                xAxes: [
                                    {
                                        stacked: true,
                                        barPercentage: 0.6,
                                        categoryPercentage: 0.8,
                                        gridLines: {
                                            display: false,
                                            color: 'white',
                                            borderColor: 'white'
                                        },
                                        ticks: {
                                            fontColor: 'rgb(25 118 210)',
                                            borderColor: 'rgb(25 118 210)'
                                        }
                                    }
                                ],
                                yAxes: [
                                    {
                                        stacked: true,
                                        gridLines: {
                                            display: false
                                        },
                                        ticks: {
                                            fontColor: 'rgb(25 118 210)',
                                            callback: function(value) {
                                                return formatBRL(value);
                                            }
                                        }
                                    }
                                ]
                            }
                        }
                    };
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.carregandoValoresRecuperados = false;
            }
        },
        getDataMounted(days = 365, filterParam = null) {
            this.carregandoTotalUploads = true;
            this.carregandoChartRecuperados = true;

            let ChartService = new ChartsService(Vue.http, this.$store);

            ChartService.graficoTotalTitulosUpload(days, filterParam)
                .then(
                    response => {
                        this.dataTotalUpload = response.data;
                        this.dataTotalUpload.anomes = this.dataTotalUpload.anomes.map(
                            this.changeLabels
                        );
                        this.fillDataTotalUpload();
                    },
                    error => {
                        this.mensagem = error;
                        this.dialogLoading = false;
                        console.log(error);
                    }
                )
                .catch(e => {
                    console.log(e);
                })
                .finally(() => {
                    this.carregandoTotalUploads = false;
                });
            ChartService.graficoTitulosRecuperados(days, filterParam)
                .then(
                    response => {
                        this.dataRecuperados = response.data;
                        this.dataRecuperados.anomes = this.dataRecuperados.anomes.map(
                            this.changeLabels
                        );
                        this.fillDataRecuperados();
                    },
                    error => {
                        this.mensagem = error;
                        this.dialogLoading = false;
                        console.log(error);
                    }
                )
                .catch(e => {
                    console.log(e);
                })
                .finally(() => {
                    this.carregandoChartRecuperados = false;
                });
        },
        changeLabels(anomes) {
            const [ano, mes] = anomes.split('-');

            const referenciaMeses = {
                '01': 'Jan',
                '02': 'Fev',
                '03': 'Mar',
                '04': 'Abr',
                '05': 'Mai',
                '06': 'Jun',
                '07': 'Jul',
                '08': 'Ago',
                '09': 'Set',
                '10': 'Out',
                '11': 'Nov',
                '12': 'Dez'
            };

            return `${referenciaMeses[mes]}/${ano}`;
        },
        onPanelChange(val) {
            this.isPanelExpanded = val === 0;
        },
        async initializeQuadroItems() {
            this.carregandoQuadroInformacoes = true;
            try {
                const dashboardService = new DashboardService(
                    Vue.http,
                    this.$store
                );
                const response = await dashboardService.getQuadroInformacoes();
                if (response.status === 200) {
                    this.quadroItems = this.quadroItems.map(item => ({
                        ...item,
                        valor: response.data[item.key] || 0
                    }));
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.carregandoQuadroInformacoes = false;
            }
        },
        onPeriodoChange() {
            if (this.isMobile) {
                this.periodoSelecionado = 90;
                return;
            }

            let filterParam = {};

            if (
                this.filtros.nm_cedente &&
                this.filtros.nm_cedente.trim() !== ''
            ) {
                filterParam.nm_cedente_favorecido = this.filtros.nm_cedente;
            }

            if (
                this.filtros.cnpj_sacador &&
                this.filtros.cnpj_sacador.trim() !== ''
            ) {
                filterParam.cnpj_sacador = this.filtros.cnpj_sacador;
            }

            const finalFilter =
                Object.keys(filterParam).length > 0 ? filterParam : null;

            this.getValoresEnviadosChart(this.periodoSelecionado, finalFilter);
            this.getValoresRecuperadosChart(
                this.periodoSelecionado,
                finalFilter
            );
            this.getDataMounted(this.periodoSelecionado, finalFilter);
        },
        hasChartData(chartData) {
            if (!chartData) return false;
            if (
                Array.isArray(chartData.labels) &&
                chartData.labels.length > 0
            ) {
                if (Array.isArray(chartData.datasets)) {
                    return chartData.datasets.some(
                        ds =>
                            Array.isArray(ds.data) && ds.data.some(val => !!val)
                    );
                }
                return true;
            }
            if (
                Array.isArray(chartData.anomes) &&
                chartData.anomes.length > 0
            ) {
                return true;
            }
            if (Array.isArray(chartData) && chartData.length > 0) {
                return true;
            }
            return false;
        },
        expandirImagem(item) {
            this.imagemSelecionada = item;
            this.dialogImagemExpandida = true;
        },
        async fecharImagemExpandida() {
            this.loadingImagem = true;
            if (this.imagemSelecionada) {
                try {
                    const divulgacaoService = new DivulgacaoService(
                        Vue.http,
                        this.$store
                    );
                    await divulgacaoService.marcarComoVisualizado(
                        this.imagemSelecionada.id
                    );
                } catch (error) {
                    console.error('Erro ao marcar como visualizado:', error);
                }
            }
            this.loadingImagem = false;
            this.dialogImagemExpandida = false;
            this.imagemSelecionada = null;
            this.isFullscreen = false;
        },
        async baixarImagem(item) {
            try {
                const response = await fetch(item.imagem_url);
                const blob = await response.blob();

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;

                const urlParts = item.imagem_url.split('/');
                const fileName =
                    urlParts[urlParts.length - 1] ||
                    `divulgacao_${item.id}.${blob.type.split('/')[1]}`;

                link.download = fileName;
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('Erro ao baixar imagem:', error);
                window.open(item.imagem_url, '_blank');
            }
        },
        formatarData(dataString) {
            if (!dataString) return '';
            const data = new Date(dataString);
            return data.toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        },
        async buscarAtualizacoes() {
            try {
                const divulgacaoService = new DivulgacaoService(
                    Vue.http,
                    this.$store
                );
                const response = await divulgacaoService.buscarAtualizacoes();
                if (response.data && response.data.divulgacao) {
                    this.imagemSelecionada = response.data.divulgacao;
                    this.dialogImagemExpandida = true;
                }
            } catch (error) {
                console.error('Erro ao buscar atualizações:', error);
            }
        }
    }
};
</script>

<style>
.v-sheet--offset {
    top: -24px;
    position: relative;
    z-index: 2;
}

.homeGraf {
    min-height: 100px;
    font-size: 1.3rem !important;
}

.v-expansion-panel-header {
    padding: 0 !important;
}

.v-expansion-panel-content__wrap {
    padding: 12px;
}

.remove-border-table .text-start {
    border: none;
    border-bottom: unset !important;
}

/* Add these new styles */
.periodo-select .v-label {
    color: black !important;
    font-weight: 500 !important;
    opacity: 1 !important;
    z-index: 1;
    caret-color: black !important;
}

/* Target the unfocused and focused states */
.periodo-select.v-text-field--outlined .v-label,
.periodo-select.v-text-field--outlined.v-input--is-focused .v-label,
.periodo-select.v-text-field--outlined.v-input--has-state .v-label {
    color: black !important;
    opacity: 1 !important;
    text-shadow: 0 0 1px rgba(0, 0, 0, 0.4);
}

/* Make the select arrow white */
.periodo-select .v-input__icon--append .v-icon {
    color: black !important;
}

/* Style the outline */
.periodo-select.v-text-field--outlined fieldset {
    border-color: rgba(255, 255, 255, 0.7) !important;
}

.bvs-white-label {
    background: #cdf3ff !important;
    color: #007298 !important;
}

.bvs-white-label .v-alert__content {
    color: #007298 !important;
}

.bvs-white-label .v-alert__icon.v-icon {
    color: #007298 !important;
}
</style>
